import type { IntlShape } from '@redbubble/next/intl';
import { ShippingMethod } from '../../types/cart/ShippingMethod';
import { messages } from './messages';

export interface GetShippingTitleParams {
  intl: IntlShape;
  shippingMethod: ShippingMethod;
  isShippingEstimated?: boolean;
  flatRateApplied?: boolean;
}

export const getShippingTitle = ({
  intl,
  shippingMethod,
  isShippingEstimated,
  flatRateApplied,
}: GetShippingTitleParams): string => {
  const standardShippingTitle = flatRateApplied
    ? intl.formatMessage(messages.flatRateShipping)
    : intl.formatMessage(
        isShippingEstimated
          ? messages.standardShippingEstimated
          : messages.standardShipping
      );

  const expressShippingTitle = intl.formatMessage(
    isShippingEstimated
      ? messages.expressShippingEstimated
      : messages.expressShipping
  );

  const shippingTitle =
    shippingMethod === ShippingMethod.Standard
      ? standardShippingTitle
      : expressShippingTitle;

  return shippingTitle;
};
